import React, { Component } from 'react';
import { connect } from 'react-redux';

import CSS from './styles.scss';
import { sortNotebookAnnotations } from 'PipeRouter';
import { CaretDown as CDIcon } from 'Shared/Icons';

const Fragment = React.Fragment;
const keys = {
  tab: 9,
  enter: 13,
  esc: 27,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  shift: 16
};

//how to display?
class SortByMenu extends Component {
  onSortOrderChange = event => {
    const { currentTarget } = event;
    const order = currentTarget.textContent;
    const button = currentTarget.parentElement.parentElement.querySelector('button');
    const { sortNotebookAnnotations, sortOrder } = this.props;
    
    if (sortOrder !== order) {
      sortNotebookAnnotations(order);
    }
    setTimeout(() => {
      if (button) button.focus();
    }, 100);
  };

  openMenu = event => {
    const button = event.currentTarget.querySelector('button');
    const isExpanded = button.getAttribute('aria-expanded');

    const expandedStatusChanged = isExpanded !== 'true'

    button.setAttribute('aria-expanded', expandedStatusChanged);
    const menu = event.currentTarget.querySelector('ul');
    const toDisplay = expandedStatusChanged ? "display: block;" : "display: none;";
    menu.setAttribute('style', toDisplay);

    const listItems = menu.querySelectorAll('li');
    listItems[0].focus();

    event.preventDefault();
    event.stopPropagation();
  };

  renderMenu = () => {
    return (
      <div className={CSS['menu-container']}>
        <ul role="menu" className={CSS['list']} tabIndex="0">
          <li className={CSS['list-item']} onClick={this.onSortOrderChange} tabIndex="-1">Newest</li>
          <li className={CSS['list-item']} onClick={this.onSortOrderChange} tabIndex="-1">Oldest</li>
        </ul>
      </div>
    );
  };

  onMenuItemKeyDown = event => {
    const { currentParentIndex, goToNextMenuFromSubmenu } = this.props;
    const { keyCode, target } = event;
    const { nextElementSibling, previousElementSibling, parentNode } = target;
    const menuItems = parentNode.children;
    const firstMenuItem = menuItems[0];
    const miLen = menuItems.length;
    const lastMenuItem = menuItems[miLen - 1];

    if (keyCode === keys.tab) {
      if (event.shiftKey) {
        const parent = target.parentElement.parentElement;
        parent.querySelector('button').setAttribute('aria-expanded', false);
        goToNextMenuFromSubmenu(parent, currentParentIndex - 1);
        // event.preventDefault();
        const menu = target.parentElement;
        menu.setAttribute('style', "display: none;");
        event.stopPropagation();
      } else {
        const parent = target.parentElement.parentElement;
        parent.querySelector('button').setAttribute('aria-expanded', false);
        goToNextMenuFromSubmenu(parent, currentParentIndex + 1, "yes");
        //const parent2 = target.parentElement.parentElement.querySelector('button');
        //parent2.focus();
        // event.preventDefault();
        const menu = target.parentElement;
        menu.setAttribute('style', "display: none;");
        event.stopPropagation();
      }
    }

    if (keyCode === keys.esc) {
      const parent = target.parentElement.parentElement;
      parent.querySelector('button').setAttribute('aria-expanded', false);
      parent.querySelector('button').focus();
      const menu = target.parentElement;
      menu.setAttribute('style', "display: none;");
    }

    if (keyCode === keys.down) {
      if (nextElementSibling) {
        nextElementSibling.focus();
        event.preventDefault();
        event.stopPropagation();
      } else {
        firstMenuItem.focus();
        event.preventDefault();
        event.stopPropagation();
      }
    }

    if (keyCode === keys.up) {
      if (previousElementSibling) {
        previousElementSibling.focus();
        event.preventDefault();
        event.stopPropagation()
        return false;
      } else {
        lastMenuItem.focus();
        event.preventDefault();
        event.stopPropagation()
        return false;
      }
    }

    if (keyCode === keys.right) {
      const parent = target.parentElement.parentElement;
      parent.querySelector('button').setAttribute('aria-expanded', false);
      goToNextMenuFromSubmenu(parent, currentParentIndex + 1);
      // event.preventDefault();
      event.stopPropagation();
    }

    if (keyCode === keys.left) {
      const parent = target.parentElement.parentElement;
      parent.querySelector('button').setAttribute('aria-expanded', false);
      goToNextMenuFromSubmenu(parent, currentParentIndex - 1);
      // event.preventDefault();
      event.stopPropagation();
    }

    if (keyCode === keys.enter || keyCode === keys.space) {
      target.parentElement.parentElement.querySelector('button').setAttribute('aria-expanded', false);
      this.onSortOrderChange(event);
      const menu = target.parentElement;
      menu.setAttribute('style', "display: none;");      
      // event.preventDefault();
      event.stopPropagation();
    }
  };

  onMenuKeyDown = event => {
    const { currentParentIndex, goToNextMenu, updateParentIndex } = this.props;
    const { keyCode, target } = event;
    const menus = target.parentElement.getElementsByClassName('menu');
    const mLen = menus.length;

    if (keyCode === keys.up) {
      const menu = target.parentElement.querySelector('ul');
      const button = target.parentElement.querySelector('button');

      if (menu.children.length > 0) {
        const listItems = menu.querySelectorAll('li');
        button.setAttribute('aria-expanded', true);
        listItems[listItems.length - 1].focus();
        menu.setAttribute('aria-activedescendant', listItems.length - 1);
      }
    }

    if (keyCode === keys.down || keyCode === keys.space || keyCode === keys.enter) {
      const menu = target.parentElement.querySelector('ul');
      const button = target.parentElement.querySelector('button');

      if (menu.children.length > 0) {
        const listItems = menu.querySelectorAll('li');
        button.setAttribute('aria-expanded', true);
        menu.setAttribute('aria-activedescendant', 0)
        menu.setAttribute('style', "display: block;");
        listItems[0].focus();
      }
    }

    if (keyCode === keys.tab) {
      if (event.shiftKey) {
        if (currentParentIndex - 1 < 0) {
          updateParentIndex(0);
        } else {
          goToNextMenu(target.parentElement, currentParentIndex - 1);
          // event.preventDefault();
        }
      } else {
        if (currentParentIndex === mLen - 1) {
          updateParentIndex(mLen - 1);
        } else {
          goToNextMenu(target.parentElement, currentParentIndex + 1);
          // event.preventDefault();
        }
      }
    }

    if (keyCode === keys.right) {
      if (currentParentIndex === mLen - 1) {
        goToNextMenu(target.parentElement, 0);
        // event.preventDefault();
      } else {
        goToNextMenu(target.parentElement, currentParentIndex + 1);
        // event.preventDefault();
      }
    }

    if (keyCode === keys.left) {
      if (currentParentIndex === 0) {
        goToNextMenu(target.parentElement, mLen - 1);
        // event.preventDefault();
      } else {
        goToNextMenu(target.parentElement, currentParentIndex - 1);
        // event.preventDefault();
      }
    }
  };

  render() {
    const { sortOrder } = this.props;

    return (
      <Fragment>
        <span className={CSS['filter_title']}>Sort by:</span>
        <li id="sortBy" data-test-id="sort-by-menu" className={`menu ${CSS['menuA']}`}
          onKeyDown={this.onMenuKeyDown}
          onClick={this.openMenu}
        >
          <button type="button" data-test-id="sort-by-button" className={CSS['filter_subTitle']} aria-label={`Sorted By ${sortOrder} Selected`} aria-haspopup="true" aria-controls="menusID2" aria-expanded={false} >{sortOrder} <CDIcon width="8px" height="6px" viewBox="0 0 8 6" fill="#00758e" /></button>
          <ul role="menu" className={CSS['submenu']} id="menusID2" aria-labelledby="menusID2" tabIndex="-1" style={{ display: 'none' }}>
            <li id="0" data-test-id="sort-by-newest" role="menuitem" tabIndex="-1" className={CSS['list-item']} onKeyDown={this.onMenuItemKeyDown} onClick={this.onSortOrderChange} aria-label={"Newest"}>
              <span className={CSS['text']} aria-hidden={true}>Newest</span>
            </li>
            <li id="1" data-test-id="sort-by-oldest" role="menuitem" tabIndex="-1" className={CSS['list-item']} onKeyDown={this.onMenuItemKeyDown} onClick={this.onSortOrderChange} aria-label={"Oldest"}>
              <span className={CSS['text']} aria-hidden={true}>Oldest</span>
            </li>
          </ul>
        </li>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { notebook: { sortOrder } } = state;
  return { sortOrder };
}


export default connect(mapStateToProps, {
  sortNotebookAnnotations
})(SortByMenu);
